/** NGXS storage-plugin key for persisted auth company (see store.module.ts). */
export const NGXS_AUTH_COMPANY_STORAGE_KEY = 'auth.company';
